class HHArticleGrid extends HTMLElement {
  constructor() {
    super();

    this.oneColumnLayoutToggle = this.querySelector('.js-one-column-toggle');
    this.twoColumnLayoutToggle = this.querySelector('.js-two-column-toggle');
  }

  connectedCallback() {
    this.oneColumnLayoutToggle.addEventListener('click', this.handleOneColumnToggle.bind(this));
    this.twoColumnLayoutToggle.addEventListener('click', this.handleTwoColumnToggle.bind(this));
  }
  
  disconnectedCallback() {
    this.oneColumnLayoutToggle.removeEventListener('click', this.handleOneColumnToggle.bind(this));
    this.twoColumnLayoutToggle.removeEventListener('click', this.handleTwoColumnToggle.bind(this));
  }

  handleOneColumnToggle() {
    this.classList.add('blog-category-grid--one-column');
    this.oneColumnLayoutToggle?.classList.add('blog-category-grid__control--active')
    this.twoColumnLayoutToggle?.classList.remove('blog-category-grid__control--active')
  }
  
  handleTwoColumnToggle() {
    this.classList.remove('blog-category-grid--one-column');
    this.oneColumnLayoutToggle?.classList.remove('blog-category-grid__control--active')
    this.twoColumnLayoutToggle?.classList.add('blog-category-grid__control--active')
  }
}

customElements.define('hh-article-grid', HHArticleGrid);